import {
  CheckCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  MoreOutlined,
  ReloadOutlined,
  UndoOutlined,
} from "@ant-design/icons";
import { Button, Dropdown } from "antd";
import type { MenuProps } from "antd";
import type { MouseEvent } from "react";

import type { ProjectListItem, ProjectStatus } from "../../api/projects";

const PROJECT_STATUS_LABELS: Record<ProjectStatus, string> = {
  SUBMITTED: "已提交",
  COMPLETED: "已完成",
};

interface ProjectActionsMenuProps {
  project: ProjectListItem;
  isAdmin: boolean;
  recycleBin: boolean;
  className: string;
  onView: (project: ProjectListItem) => void;
  onEdit: (project: ProjectListItem) => void;
  onChangeStatus: (project: ProjectListItem, status: ProjectStatus) => void;
  onDelete: (project: ProjectListItem) => void;
  onRestore: (project: ProjectListItem) => void;
}

export function ProjectActionsMenu({
  project,
  isAdmin,
  recycleBin,
  className,
  onView,
  onEdit,
  onChangeStatus,
  onDelete,
  onRestore,
}: ProjectActionsMenuProps) {
  const nextStatus: ProjectStatus = project.status === "COMPLETED" ? "SUBMITTED" : "COMPLETED";
  const menuItems: MenuProps["items"] = [
    { key: "view", icon: <EyeOutlined />, label: "查看项目" },
    ...(!isAdmin && !recycleBin
      ? [{ key: "edit", icon: <EditOutlined />, label: "编辑资料与附件" }]
      : []),
    ...(isAdmin && !recycleBin
      ? [
          {
            key: "status",
            icon: project.status === "COMPLETED" ? <UndoOutlined /> : <CheckCircleOutlined />,
            label: `标记为${PROJECT_STATUS_LABELS[nextStatus]}`,
          },
        ]
      : []),
    { type: "divider" as const },
    ...(recycleBin
      ? [{ key: "restore", icon: <ReloadOutlined />, label: "恢复项目" }]
      : [{ key: "delete", icon: <DeleteOutlined />, label: "删除项目", danger: true }]),
  ];

  const handleMenuClick: MenuProps["onClick"] = ({ key, domEvent }) => {
    domEvent.stopPropagation();
    if (key === "view") onView(project);
    if (key === "edit") onEdit(project);
    if (key === "status") onChangeStatus(project, nextStatus);
    if (key === "delete") onDelete(project);
    if (key === "restore") onRestore(project);
  };
  const stopPropagation = (event: MouseEvent) => event.stopPropagation();

  return (
    <Dropdown trigger={["click"]} menu={{ items: menuItems, onClick: handleMenuClick }}>
      <Button
        className={className}
        type="text"
        shape="circle"
        icon={<MoreOutlined />}
        aria-label={`打开${project.work_name}的操作菜单`}
        onClick={stopPropagation}
      />
    </Dropdown>
  );
}
